import { CompanyState } from "ducks/company/type";
export const initialState: CompanyState = {
  isLoading: false,
  profile: { contents: [], totalCount: 0, offset: 0, limit: 0 },
  law: { contents: [], totalCount: 0, offset: 0, limit: 0 },
  tos: { tos: "" },
};
